import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Home() {
  useEffect(() => {
    const sections = document.querySelectorAll('.section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          } else {
            entry.target.classList.remove('in-view');
          }
        });
      },
      {
        threshold: 0.5, // Adjust this threshold as needed
      }
    );

    sections.forEach(section => {
      observer.observe(section);
    });

    return () => {
      sections.forEach(section => {
        observer.unobserve(section);
      });
    };
  }, []);

  const handleScrollTo = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
  };

return (
    <div>
      <main>
      <section id="generate" className="section generate">
          <div className="section-content">
            <Link to="/image">
              <button className="nav-button">Generate your AI GF</button>
            </Link>
          </div>
      </section>
      <section id="chat" className="section chat">
          <div className="section-content">
            <Link to="/chat">
              <button className="nav-button">Visit your AI GF</button>
            </Link>
          </div>
        </section>
        <section id="scenario" className="section scenario">
          <div className="section-content">
            <Link to="/scenario">
              <button className="nav-button">Play with your AI GF</button>
            </Link>
          </div>
        </section>
        <section id="challenge" className="section challenge">
          <div className="section-content">
            <Link to="/challenge">
              <button className="nav-button">Enter a Versus</button>
            </Link>
          </div>
        </section>
      </main>

      {/* Floating Sidebar */}
      <div className="floating-sidebar">
        <ul>
          <li><button onClick={() => handleScrollTo('generate')}>Generate</button></li>
          <li><button onClick={() => handleScrollTo('chat')}>Visit</button></li>
          <li><button onClick={() => handleScrollTo('scenario')}>Play</button></li>
          <li><button onClick={() => handleScrollTo('challenge')}>Versus</button></li>
        </ul>
      </div>
    </div>
  );
}

export default Home;
